export enum RegionType {
  LicenceArea = 1,
  District = 2,
  Company = 3,
  Site = 4,
  County = 5,
}
